import BrightcoveVideo from "@atoms/players/BrightcoveVideo";
import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, Element } from "html-react-parser";

/**
 * Renders a Brightcove video element in an article.
 * This component processes the body string to extract the video ID and renders the Brightcove player.
 */
const InlineBrightcove = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformVideo = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "iframe") {
      const el = node;

      const src = el.attribs["src"];
      const urlParams = new URLSearchParams(src.split("?")[1]);
      const videoId = urlParams.get("videoId") || "";

      return (
        <BrightcoveVideo
          videoId={videoId}
          className={cn("mb-6", className, paragraphWidth)}
        />
      );
    }
  };

  return (
    <div data-testid="article-inline-bightcove-component">
      {parse(bodyString, { replace: transformVideo })}
    </div>
  );
};

export default InlineBrightcove;
